import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const IOSSwitch = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  overflow: 'visible',
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 0,
    top: '50%',
    left: 2,
    transform: 'translateY(-50%)',
    transitionDuration: '200ms',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'transparent',
    },
    '&.Mui-checked': {
      transform: 'translate(16px, -50%)',
      color: '#fff',
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '& + .MuiSwitch-track': {
        backgroundColor: '#65C466',
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 1px 3px rgba(17, 24, 39, 0.16)',
    boxSizing: 'border-box',
    width: 22,
    height: 22,
    borderRadius: '50%',
    backgroundColor: '#fff',
  },
  '& .MuiSwitch-track': {
    borderRadius: 12,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    boxSizing: 'border-box',
    overflow: 'hidden',
    transition: theme.transitions.create(['background-color'], {
      duration: 200,
    }),
  },
}));

export default IOSSwitch;
